import { EyeClosedIcon, EyeIcon, UserPlus2 } from "lucide-react";
import { CreateUserDto } from "../../../models/User";

import { FunctionComponent, useState, FormEvent, ChangeEvent } from "react";
import { createSupplier } from "../../../store/SuppliersSlice";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";

import { Modal, FormField } from "../../ui";

type FormState = {
  email: string;
  name: string;
  login: string;
  fee: string;
  role: string;
  password: string;
};

export interface ModalSupplierProps {
   click: () => void;
}

const ModalAddSupplier: FunctionComponent<ModalSupplierProps> = ({ click }) => {

    const dispatch = useAppDispatch();
    const loader   = useAppSelector((state) => state.supplier.modalLoading);

    const [form, setForm] = useState<FormState>({
        email: "",
        name: "",
        login: "",
        fee: "0",
        role: "Supplier",
        password: "",
    });

    const [errors, setErrors] = useState<Partial<Record<keyof FormState, string>>>({});
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setForm((prev: any) => ({ ...prev, [name]: value }));
    };

    const validate = (): Partial<Record<keyof FormState, string>> => {
        const newErrors: Partial<Record<keyof FormState, string>> = {};
        if (!form.email) newErrors.email = "Email obrigatorio";
        if (!form.name)  newErrors.name  = "Name obrigatorio";
        if (!form.login) newErrors.login = "Login obrigatorio";
        if (!form.role)  newErrors.role  = "Role obrigatorio";
        return newErrors;
    };

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload: CreateUserDto = {
            email: form.email,
            name: form.name,
            login: form.login,
            role: form.role,
            ...(form.fee && { fee: form.fee }),
        };

        dispatch(createSupplier(payload));
    };

    return (
        <Modal
            open
            onClose={click}
            icon={UserPlus2}
            title="Adicionar Fornecedor"
            subtitle="adicione um fornecedor, para voce controlar suas compras."
            footer={
                <button
                    type="submit"
                    form="modal-add-supplier-form"
                    className="btn-pill primary"
                    disabled={loader || undefined}
                >
                    {loader ? <div className="loader" /> : "Adicionar"}
                </button>
            }
        >
            <form id="modal-add-supplier-form" onSubmit={handleSubmit} className="ui-stack">
                <FormField label="E-mail" htmlFor="email" error={errors.email}>
                    <input id="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} />
                </FormField>

                <FormField label="Nome" htmlFor="name" error={errors.name}>
                    <input id="name" name="name" placeholder="Name" value={form.name} onChange={handleChange} />
                </FormField>

                <FormField label="Login" htmlFor="login" error={errors.login}>
                    <input id="login" name="login" placeholder="Login" value={form.login} onChange={handleChange} />
                </FormField>

                <FormField
                    label="Senha"
                    htmlFor="password"
                    suffix={
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                background: "transparent",
                                border: 0,
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                            }}
                        >
                            {showPassword ? <EyeClosedIcon size={16} /> : <EyeIcon size={16} />}
                        </button>
                    }
                >
                    <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        placeholder="Password"
                        value={form.password}
                        onChange={handleChange}
                    />
                </FormField>
            </form>
        </Modal>
    );
};

export default ModalAddSupplier;
